// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"85":"8c40a57a","210":"49709a92","257":"3a8ac6ff","283":"c1452f41","353":"a0a6db58","366":"4712adcc","712":"3054b86b","735":"2c9fa991","761":"002937a5","834":"0b4cbf40"}[chunkId] + ".chunk.js";
};